import {useState, useCallback, useEffect} from 'react';
import { TextField, Button, FormLayout, Page, ResourceList, ResourceItem, Layout, LegacyCard, Text } from "@shopify/polaris";
import Api from '../../helpers/api';
import Paginator from "../Paginator";
import { useHistory } from "react-router-dom";
export default function BillingAddresses() {
    const [search, setSearch] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const history = useHistory();

    const loadAddresses = useCallback(async (searchQuery, pageNumber) => {
        setLoading(true);
        const response = await Api.getBillingAddresses(searchQuery, pageNumber);
        setResults(response.data.data);
        setPage(response.data.meta.current_page);
        setLastPage(response.data.meta.last_page);
        setLoading(false);
    }, []);

    useEffect(() => {
        loadAddresses('', 1);
    }, [loadAddresses]);

    const handleSearch = useCallback(() => {
        loadAddresses(search, 1);
    }, [search, loadAddresses]);

    return (
        <Page
            title="Billing Addresses"
            primaryAction={{
                content: 'New Address',
                onAction: () => history.push('/billingAddresses/new'),
            }}
            backAction={{ content: 'Go back', onAction: () => history.goBack() }}
        >
            <FormLayout>
                <TextField
                    label="Search"
                    value={search}
                    onChange={setSearch}
                    placeholder="Search"
                    autoComplete="off"
                    connectedRight={<Button loading={loading} onClick={handleSearch}  variant="primary">Search</Button>}
                />
                <br />
            </FormLayout>
            {results.length > 0 ? (
                <>
                            <LegacyCard title="Results">
                                <ResourceList
                                    loading={loading}
                                    resourceName={{ singular: 'Billing Addresses', plural: 'Billing Address' }}
                                    items={results}
                                    renderItem={(item) => {
                                        return (
                                            <ResourceItem
                                                id={item.id}
                                                onClick={event => { history.push(`/billingAddresses/${item.id}`); }}
                                                accessibilityLabel={`View details for user ${item.contact_email}`}
                                            >
                                                <h3>
                                                    <Text as="span" fontWeight="semibold">{item.business_name}</Text>
                                                </h3>
                                                <div>{`Email: ${item.contact_email}`}</div>
                                            </ResourceItem>
                                        );
                                    }}
                                />
                            </LegacyCard>
                            <Paginator currentPage={page} lastPage={lastPage} show={true} callback={(newPage) => loadAddresses(search, newPage)} />
                                </>
                    ) : !loading && (
                        <LegacyCard sectioned title="No results found"> </LegacyCard>
                    )}
        </Page>
    );
}
